import React from 'react';
import { motion as Motion } from 'framer-motion';

export default function AplicarSeleccion({ 
  onApplySelections, 
  hasSelections = false,
  isLoading = false 
}) {
  const handleApply = () => {
    if (onApplySelections && hasSelections && !isLoading) {
      onApplySelections();
    }
  };

  return (
    <Motion.button
      onClick={handleApply}
      disabled={!hasSelections || isLoading}
      className={`
        px-6 py-2 rounded-lg font-semibold transition-all duration-300
        ${hasSelections && !isLoading
          ? 'bg-aw-green hover:bg-aw-green/90 text-aw-bluedark scale-100 hover:scale-95 shadow-lg'
          : 'bg-gray-400 text-gray-600 cursor-not-allowed'
        }
      `}
      whileHover={hasSelections && !isLoading ? { scale: 0.95 } : {}}
      whileTap={hasSelections && !isLoading ? { scale: 0.90 } : {}}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {isLoading ? (
        <div className="flex items-center gap-2">
          <Motion.div
            className="w-4 h-4 border-2 border-aw-bluedark border-t-transparent rounded-full"
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          />
          Aplicando...
        </div>
      ) : (
        'Aplicar Selecciones'
      )}
    </Motion.button>
  );
}